import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ClientLayout from "../components/layout/ClientLayout";
import axiosInstance from "../../../utils/axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
    const [initialValues, setInitialValues] = useState(null);

    const [passwordValues, setPasswordValues] = useState({
        passpin: "",
    });

    useEffect(() => {
      const fetchProfile = async () => {
        try {
          const { data } = await axiosInstance.get("/profile");

          setInitialValues({
            stake1: data.response.stake1,
            stake2: data.response.stake2,
            stake3: data.response.stake3,
            stake4: data.response.stake4,
            stake5: data.response.stake5,
            stake6: data.response.stake6,
            stake7: data.response.stake7,
            stake8: data.response.stake8
          });
        } catch (error) {
          console.error("Failed to load profile data:", error);
        }
      };

      fetchProfile();
    }, []);

    const validationSchema = Yup.object().shape({
      stake1: Yup.number().required("Required"),
      stake2: Yup.number().required("Required"),
      stake3: Yup.number().required("Required"),
      stake4: Yup.number().required("Required"),
      stake5: Yup.number().required("Required"),
      stake6: Yup.number().required("Required"),
      stake7: Yup.number().required("Required"),
      stake8: Yup.number().required("Required")
    });

    const passwordSchema = Yup.object().shape({
      passpin: Yup.string().min(6, "Minimum 6 characters").required("Required")
    });

    const handleStakeSubmit = async (values, { setSubmitting }) => {
      try {
        const response = await axiosInstance.post("/profile", values);

        if (
          response.data !== undefined &&
          response.data !== null &&
          response.data.status !== undefined &&
          response.data.status !== null
        ) {
          if (response.data.status) {
            toast.success(response.data.message);
          } else {
            toast.error(response.data.message);
          }
        }
        //alert("Stake settings updated successfully.");
      } catch (error) {
        console.error("Error updating stake settings:", error);
        alert("Failed to update stake settings.");
      } finally {
        setSubmitting(false);
      }
    };

    const handlePasswordSubmit = async (
      values,
      { setSubmitting, resetForm }
    ) => {
      try {
        const response = await axiosInstance.post("/profile/password", values);
        if (
          response.data !== undefined &&
          response.data !== null &&
          response.data.status !== undefined &&
          response.data.status !== null
        ) {
          if (response.data.status) {
            resetForm();
            toast.success(response.data.message);
          } else {
            toast.error(response.data.message);
          }
        }
      } catch (error) {
        console.error("Error updating password:", error);
        alert("Failed to update password.");
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <ClientLayout>
        <div className="container-fluid">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleStakeSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div
                  className="row"
                  style={{ marginTop: "10px", marginBottom: "0px" }}
                >
                  <div className="col-12 col-md-12 pdRleft pdtop">
                    <div className="card" style={{ marginBottom: "8px" }}>
                      <div
                        className="card-header"
                        style={{
                          backgroundColor: "#f7f7f7",
                          padding: "5px 5px 5px 18px"
                        }}
                      >
                        <strong>Profile</strong>
                      </div>
                      <div className="card-body" style={{ paddingTop: "10px" }}>
                        {[1, 2, 3, 4].map((i) => (
                          <div className="form-group row" key={`stake${i}`}>
                            <label className="col-md-3 col-form-label">
                              Stake{i}
                            </label>
                            <div className="col-md-6">
                              <Field
                                className="form-control"
                                type="number"
                                name={`stake${i}`}
                              />
                            </div>
                          </div>
                        ))}
                        {[5, 6, 7, 8].map((i) => (
                          <div className="form-group row" key={`stake${i}`}>
                            <label className="col-md-3 col-form-label">
                              Plus{i - 4}
                            </label>
                            <div className="col-md-6">
                              <Field
                                className="form-control"
                                type="number"
                                name={`stake${i}`}
                              />
                            </div>
                          </div>
                        ))}
                        <div className="form-actions">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isSubmitting}
                            style={{
                              backgroundColor: "#00b181",
                              border: "none"
                            }}
                          >
                            Save changes
                          </button>
                          <button
                            className="btn btn-danger"
                            type="button"
                            style={{ marginLeft: "5px" }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          <Formik
            initialValues={passwordValues}
            validationSchema={passwordSchema}
            onSubmit={handlePasswordSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div
                  className="row"
                  style={{ marginTop: "5px", marginBottom: "1%" }}
                >
                  <div className="col-12 col-md-12 pdRleft">
                    <div className="card">
                      <div
                        className="card-header"
                        style={{
                          backgroundColor: "#f7f7f7",
                          padding: "5px 5px 5px 18px"
                        }}
                      >
                        <strong>Change Password</strong>
                      </div>
                      <div className="card-body">
                        <div
                          className="form-group row"
                          style={{ marginTop: "10px" }}
                        >
                          <label className="col-md-3 col-form-label">
                            New Password
                          </label>
                          <div className="col-md-6">
                            <Field
                              className="form-control"
                              type="password"
                              name="passpin"
                            />
                            <ErrorMessage
                              name="passpin"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </div>
                        <div className="form-actions">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isSubmitting}
                            style={{
                              backgroundColor: "#00b181",
                              border: "none"
                            }}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <ToastContainer />
      </ClientLayout>
    );
};

export default Profile;
